import React, {FunctionComponent} from 'react'
import { useQueries } from '../../../../../utils/hooks/useQueries'
import TaskFiltersDesktop from './TaskFiltersDesktop'
import TaskFiltersMobile from './TaskFiltersMobile'

const TaskFilters: FunctionComponent = () => {
    const {isMobile} = useQueries()

    return isMobile?
        <TaskFiltersMobile/>:
        <TaskFiltersDesktop/>
}

export default TaskFilters